// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_ToggleActiveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/devices_franquias/toggle_active
 *
 * Toggles the active status of a WhatsApp device.
 */
import { registerContract } from './validate'

export interface DevicesFranquias_ToggleActiveInput {
device_id: number
active: boolean
}

registerContract('DevicesFranquias_ToggleActiveInput', {
  device_id: { type: 'number',  required: true },
  active:    { type: 'boolean', required: true },
})
